var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"newstooltip"},[_vm._v("Text: "+_vm._s(_vm.tooltipInfo.nw_description))])])}
var staticRenderFns = []

export { render, staticRenderFns }